/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orders: NonNullable<unknown>, qty: NonNullable<unknown>, unit: NonNullable<unknown> }} Lot_Debt_Fill_CountInputs */

const vi_lot_debt_fill_count = /** @type {(inputs: Lot_Debt_Fill_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.orders} đơn · ${i?.qty} ${i?.unit}`)
};

/**

* @param {Lot_Debt_Fill_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_debt_fill_count = /** @type {((inputs: Lot_Debt_Fill_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Debt_Fill_CountInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_debt_fill_count(inputs)
});